import translations from './translations.json';

export const numberFormats = {
  'da-DK': {
    currency: {
      style: 'currency',
      currency: 'DKK',
    }
  }
}

export const dateTimeFormats = {
  'da-DK': {
    time: {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    },
    short: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
    shortWithTime: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }
  }
};

export default {
  ...translations
}
